import { Component, defineElement, FC, onDidLoad, useElement, useProp } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { setData } from '@features/virtual-tour/store';
import { VirtualView } from '@features/virtual-tour/types';

const VirtualTourWrapper: FC = () => {
    const [viewsJSON] = useProp<string>('views');
    const [firstViewId] = useProp<string | null>('firstSceneId', null);

    const [vrTourId] = useProp<string>('vrTourId');
    const [controls] = useProp<boolean>('controls', false);

    const virtualTour = useElement<Component>('virtual-tour');

    let views: VirtualView[];

    try {
        views = JSON.parse(viewsJSON) as VirtualView[];
    } catch (e) {
        console.log('Invalid JSON', e);
    }

    onDidLoad(async () => {
        if (!views) return;
        if (!virtualTour.current?.connected) await virtualTour.current?.componentOnReady();
        setData(vrTourId, { views, firstViewId });
    });

    return <virtual-tour id={vrTourId} controls={controls} />;
};

VirtualTourWrapper.props = {
    views: {
        type: String,
        required: true,
        reflectToAttr: true,
    },
    firstSceneId: {
        type: String,
        reflectToAttr: true,
    },
    vrTourId: {
        type: String,
        required: true,
        reflectToAttr: true,
    },
    controls: {
        type: Boolean,
    },
};

defineElement('virtual-tour-wrapper', VirtualTourWrapper);
